export type normal = "normal";
export type nowrap = "nowrap";
export type pre = "pre";
export type pre_wrap = "pre-wrap";
export type pre_line = "pre-line";
export type break_spaces = "break-spaces";

export type inherit = "inherit";
export type initial = "initial";
export type unset = "unset";


//  export\s*type\s*((?:\w|_)+)\s*=\s*"(.+?)";
//    $1 |

export type CSSWhiteSpaceType = 
  normal |
  nowrap |
  pre |
  pre_wrap |
  pre_line |
  break_spaces |

  inherit |
  initial |
  unset 
;

export class CSSWhiteSpace
{
  //  export\s*type\s*((?:\w|_)+)\s*=\s*"(.+?)";
  //  static readonly $1:$1 = "$2";

  static readonly normal:normal = "normal";
  static readonly nowrap:nowrap = "nowrap";
  static readonly pre:pre = "pre";
  static readonly pre_wrap:pre_wrap = "pre-wrap";
  static readonly pre_line:pre_line = "pre-line";
  static readonly break_spaces:break_spaces = "break-spaces";
  
  static readonly inherit:inherit = "inherit";
  static readonly initial:initial = "initial";
  static readonly unset:unset = "unset";
  
}